var _circle, _ellipse, _path, _path2, _ellipse2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiredIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    fill: "#FFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 65.7545,
    rx: 15.125,
    ry: 3.025,
    fill: "#6C5BE2",
    stroke: "#4025F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9375 62.8437L36.8195 66.3597H54.3645L57.9944 65.1497L58.9407 62.9797C59.2044 60.8749 55.6401 59.004 53.4375 57.9999C50.768 56.7831 48.6019 53.939 46.6019 53.939C43.8578 53.939 42.4157 56.8432 40.4328 58.2452C38.9019 59.3277 35.8125 59.1874 33.9375 62.4531V62.8437Z",
    fill: "#A193FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8298 27.4966H40.1917C32.8585 27.4966 32.2929 34.0887 36.252 37.6773L56.7694 56.3224C60.7286 59.911 60.163 66.503 52.8298 66.503H40.1917C32.8585 66.503 32.2929 59.911 36.252 56.3224L56.7694 37.6773C60.7286 34.0887 60.163 27.4966 52.8298 27.4966Z",
    stroke: "#4025F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 28.2447,
    rx: 15.125,
    ry: 3.025,
    fill: "#6C5BE2",
    stroke: "#4025F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.625 65.7546L61.625 28.2446",
    stroke: "#4025F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 65.7546L31.375 28.2446",
    stroke: "#4025F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredIcon);
export default __webpack_public_path__ + "static/media/expired_icon.0b7a4dd7ca46871aadea4ec40d3cd556.svg";
export { ForwardRef as ReactComponent };